import './board.styles.css';

const Board = ({ cat }) => {
    const { state, boardClass } = cat;

    return (
        <div className={`board-wrapper ${boardClass} ${state === "true" ? "on-board" : ""}`}>
            <span className="board-right">
                <span className="filler-boarder"></span>
            </span>
            <span className="board-left">
                <span className="filler-boarder"></span>
            </span>
        </div>
    );
};

export default Board;
